import { reloadSections } from '../../../../theme/reload-sections';
import { Context } from '../context';
const ADDITIONAL_CHECKOUT_BUTTONS_SECTION = '.js-additional-checkout-buttons-section';
const ADDITIONAL_CHECKOUT_BUTTONS = '.js-additional-checkout-buttons';
const ADDITIONAL_CHECKOUT_BUTTONS_DRAWER_PLACEMENT = '.js-additional-checkout-buttons-drawer-placement';
const SHOPIFY_SECTION_PREFIX = 'shopify-section-';
const { fetchCartContents  } = Context;
export const updateAdditionalCheckoutButtons = async ()=>{
    const sectionIds = [];
    document.querySelectorAll(ADDITIONAL_CHECKOUT_BUTTONS_SECTION).forEach((el)=>{
        const idAttr = el.id;
        if (idAttr === null || idAttr === void 0 ? void 0 : idAttr.startsWith(SHOPIFY_SECTION_PREFIX)) {
            sectionIds.push(idAttr.replace(SHOPIFY_SECTION_PREFIX, ''));
        }
    });
    if (sectionIds.length > 0) {
        await reloadSections(sectionIds, {
            context: 'current'
        });
    }
    const cart = await fetchCartContents();
    var _cart_item_count;
    const itemCount = (_cart_item_count = cart === null || cart === void 0 ? void 0 : cart.item_count) !== null && _cart_item_count !== void 0 ? _cart_item_count : 0;
    if (itemCount <= 0) return;
    const additionalCheckoutButtons = document.querySelector(`body > ${ADDITIONAL_CHECKOUT_BUTTONS_SECTION} ${ADDITIONAL_CHECKOUT_BUTTONS}`);
    const drawerPlacement = document.querySelector(ADDITIONAL_CHECKOUT_BUTTONS_DRAWER_PLACEMENT);
    if (additionalCheckoutButtons && drawerPlacement) {
        // Check if buttons are already present in the drawer placement
        const existingButtons = drawerPlacement.querySelector(ADDITIONAL_CHECKOUT_BUTTONS);
        if (existingButtons) {
            // Buttons already present, no need to replace
            return;
        }
        // Now append the element
        drawerPlacement.appendChild(additionalCheckoutButtons);
        // Cleanup function to move the element back to body when component unmounts
        return ()=>{
            if (drawerPlacement.contains(additionalCheckoutButtons)) {
                document.body.appendChild(additionalCheckoutButtons);
            }
        };
    }
};
